import TimelineItem from './TimelineItem';


TimelineItem.install = function(Vue) {
  Vue.component(TimelineItem.name, TimelineItem);
};

export default TimelineItem;
